import React, { useEffect, useState } from "react";
import { FormControl, MenuItem } from "@mui/material";
import Select from "react-select";
import styles from "./ui-element.module.scss";

export const Dropdown = ({
  topLabel,
  bottomLabel,
  options,
  placeholder,
  className,
  selectedValue,
  inputId,
  onChange,
  register,
  ...rest
}) => {
  // const [value, setValue] = useState("");

  // useEffect(() => {
  //   setValue(selectedValue);
  // }, [selectedValue]);

  // const handleChange = (e) => {
  //   const { label, value } = e;
  //   setValue(value);

  //   if (onChange) {
  //     onChange(e);
  //   }
  // };

  const customStyles = {
    control: (base, state) => ({
      ...base,
      height: "50px",
      boxShadow: " 0px 2px 5px rgba(38, 51, 77, 0.03)",
      borderColor: "none",
      "&:hover": { borderColor: "none" }, // border style on hover
      borderColor: state.isFocused ? "#e0e0e0" : "#e0e0e0",
    }),
    option: (provided, state) => ({
      ...provided,
      cursor: "pointer",
      color: state.isSelected ? "#F47F20" : "#B5B5C3",
      backgroundColor: state.isSelected
        ? "#F5F6FC"
        : state.isFocused
        ? "#fff"
        : provided.backgroundColor,
      "&:hover": {
        backgroundColor: "#F5F6FC",
        color: "#F47F20",
      },
    }),
    menuPortal: (base) => ({ ...base, zIndex: 9999 }),
  };

  return (
    <FormControl fullWidth>
      {topLabel && (
        <label className={topLabel === "transparent" && styles.transparent}>
          {topLabel}
        </label>
      )}
      <Select
        className={`${styles.select_input} ${className}`}
        options={options}
        onChange={onChange}
        placeholder={placeholder && placeholder}
        styles={customStyles}
        onChange={(val) => onChange(val.value)}
      />
      {bottomLabel && <label>{bottomLabel}</label>}
    </FormControl>
  );
};

export default Dropdown;
